import {MAT_DIALOG_DATA, MatDialogConfig} from '@angular/material/dialog';
import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {delay, Observable, of} from 'rxjs';
import {AsyncPipe} from '@angular/common';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

export const LOADING_INDICATOR_SPINNER_DIALOG_CONFIG: MatDialogConfig = {
  panelClass: 'loading-indicator-dialog-panel',
  backdropClass: 'loading-indicator-dialog-backdrop',
  disableClose: true
};

export interface LoadingIndicatorSpinnerDialogData {
  delayLoad: boolean;
}

@Component({
  selector: 'mx-loading-indicator-spinner-dialog',
  template: `
    @if (!delayLoad || (show | async) === true) {
      <mat-spinner color="primary"/>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, MatProgressSpinner]
})
export class LoadingIndicatorSpinnerDialog {
  public readonly dialogData = inject(MAT_DIALOG_DATA);
  public readonly delayLoad = this.dialogData.delayLoad;
  // Delay the appearance of the indicator.  If a loading event is very quick, the user won't see an unnecessary and disorienting split-second indicator flash.
  public readonly show: Observable<boolean> = of(true).pipe(delay(250));
}
